$(document).ready(autoquote);

function autoquote() {
    return new Promise((resolve, reject) => {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                let requestString = ''
                cart.items.forEach(lineItem => requestString += `${lineItem.sku} (${lineItem.quantity}), `)
                requestString = requestString.slice(0, -2)
                const skuInputs = document.querySelectorAll('.sku-number input');
                if (skuInputs.length > 0) {
                    skuInputs.forEach(skuInput => {
                        skuInput.value = requestString
                    });
                }
                resolve(requestString)
            })
            .catch(err => reject(err));
    })
}